import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import observeStickyElement from "./stickyStuck";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import AOS from "aos";
import addVisibleOnScroll from "./isVisible";
require("fslightbox");
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
document.addEventListener("DOMContentLoaded", function () {
	AOS.init({
		easing: "ease-in-out",
		offset: 50,
	});

	// splide carousels

	if (document.querySelector(".jsCarousel")) {
		var elms = document.getElementsByClassName("jsCarousel");

		for (var i = 0; i < elms.length; i++) {
			new Splide(elms[i], {
				type: "loop",
				drag: "free",
				focus: "center",
				perPage: 5,
				arrows: false,
				pagination: false,
				autoWidth: true,
				autoScroll: {
					speed: 1,
				},
			}).mount({ AutoScroll });
		}
	}

	if (document.querySelector(".jsSingleImageCarousel")) {
		new Splide(".jsSingleImageCarousel", {
			type: "loop",
			pagination: true,
			perPage: 1,
			autoplay: false,
		}).mount();
	}

	if (document.querySelectorAll(".jsHeroSlider")) {
		const heroSliders = document.querySelectorAll(".jsHeroSlider");
		heroSliders.forEach((slider) => {
			new Splide(slider, {
				type: "loop",
				pagination: false,
				perPage: 1,
				autoplay: true,
				interval: 6000,
				pauseOnHover: true,
				pauseOnFocus: true,
				arrows: true,
			}).mount();
		});
	}

	// images carousel with thumbnails
	if (document.querySelector(".jsGalleryParent")) {
		document.querySelectorAll(".jsGalleryParent").forEach((galleryParent) => {
			var gallery = galleryParent.querySelector(".jsGalleryMain");
			var thumbnails = galleryParent.querySelector(".jsGalleryThumbnails");
			var main = new Splide(gallery, {
				type: "fade",
				rewind: true,
				pagination: false,
				arrows: false,
			});

			var thumbnails = new Splide(thumbnails, {
				// fixedWidth: 100,
				// fixedHeight: 60,
				perPage: 5,
				gap: "1rem",
				rewind: true,
				pagination: false,
				isNavigation: true,
				breakpoints: {
					600: {
						fixedWidth: 60,
						fixedHeight: 44,
					},
				},
			});

			main.sync(thumbnails);
			main.mount();
			thumbnails.mount();
		});
	}

	if (document.querySelector(".jsCardsSlider")) {
		document.querySelectorAll(".jsCardsSlider").forEach((slider) => {
			new Splide(slider, {
				type: "slide",
				// focus: "center",
				pagination: false,
				padding: "7rem",
				perPage: 4,
				gap: "2rem",
				trimSpace: false,
				arrows: false,
				breakpoints: {
					768: {
						perPage: 1,
						padding: "3rem",
					},
					1280: {
						perPage: 2,
					},
					1700: {
						perPage: 3,
					},
				},
			}).mount();
		});
	}

	if (document.querySelector(".jsReviewsSlider")) {
		document.querySelectorAll(".jsReviewsSlider").forEach((slider) => {
			new Splide(slider, {
				type: "loop",
				pagination: true,
				perPage: 3,
				autoplay: false,
				interval: 5000,
				pauseOnHover: true,
				pauseOnFocus: true,
				gap: "1rem",
				padding: "0.75rem",
				arrows: true,
				breakpoints: {
					992: {
						perPage: 1,
					},
					1199: {
						perPage: 2,
					},
				},
			}).mount();
		});
	}

	observeStickyElement();

	if (document.querySelector(".jsTestimonials")) {
		document.querySelectorAll(".jsTestimonials").forEach((test) => {
			new Splide(test, {
				type: "loop",
				pagination: true,
				perPage: 3,
				autoplay: false,
				interval: 5000,
				pauseOnHover: true,
				pauseOnFocus: true,
				gap: "1rem",
				padding: "0.75rem",
				arrows: true,
				breakpoints: {
					992: {
						perPage: 1,
					},
					1199: {
						perPage: 2,
					},
				},
			}).mount();
		});
	}

	// Shell SVG Animation
	if (document.querySelector(".shell-divider")) {
		document.querySelectorAll(".shell-divider").forEach((shellDivider) => {
			const shell = shellDivider.querySelector(".shell");
			const dividerBefore = shellDivider.querySelector(
				".shell-divider--before",
			);
			const dividerAfter = shellDivider.querySelector(".shell-divider--after");
			const paths = [];

			// Collect all shell paths (shell-1 to shell-22)
			for (let i = 1; i <= 22; i++) {
				const path = shell.querySelector(`#shell-${i}`);
				if (path) {
					paths.push(path);
					// Hide paths initially
					gsap.set(path, { opacity: 0, scale: 0.8 });
				}
			}

			// Set initial state for divider lines
			gsap.set(dividerBefore, {
				scaleX: 0,
				transformOrigin: "right center",
			});

			gsap.set(dividerAfter, {
				scaleX: 0,
				transformOrigin: "left center",
			});

			// Create the animation timeline
			const shellTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: shellDivider,
					start: "top 90%",
					end: "bottom 10%",
					toggleActions: "play reverse play reverse",
				},
			});

			// Animate divider lines and shell paths together
			shellTimeline.to(
				[dividerBefore, dividerAfter],
				{
					scaleX: 1,
					duration: 1.4,
					ease: "power2.inOut",
				},
				0,
			);

			// Animate each path in sequence
			paths.forEach((path, index) => {
				shellTimeline.to(
					path,
					{
						opacity: 1,
						scale: 1,
						duration: 0.3,
						ease: "back.out(1.7)",
					},
					index * 0.05,
				); // Start with shell paths, stagger delay
			});
		});
	}

	if (document.querySelector(".shape-divider")) {
		addVisibleOnScroll(".shape-divider");
	}

	// Back to top button
	const backToTopBtn = document.querySelector(".btn-back-to-top");
	if (backToTopBtn) {
		// Initially hide the button
		backToTopBtn.classList.add("hidden");

		// Show/hide button based on scroll position
		window.addEventListener("scroll", function () {
			if (window.scrollY > 100) {
				backToTopBtn.classList.remove("hidden");
				backToTopBtn.classList.add("visible");
			} else {
				backToTopBtn.classList.remove("visible");
				backToTopBtn.classList.add("hidden");
			}
		});

		// Scroll to top when clicked
		backToTopBtn.addEventListener("click", function () {
			// Temporarily disable CSS smooth scroll to prevent conflict with GSAP
			document.documentElement.style.scrollBehavior = "auto";

			gsap.to(window, {
				duration: 0.6,
				scrollTo: { y: 0 },
				ease: "power2.out",
				onComplete: function () {
					// Re-enable CSS smooth scroll after animation completes
					document.documentElement.style.scrollBehavior = "smooth";
				},
			});
		});
	}
	document.querySelectorAll(".nav-dropdown-toggle").forEach(function (button) {
		button.addEventListener("click", function (event) {
			event.preventDefault();
			event.stopPropagation();

			const item = button.parentElement;
			if (!item) return;

			const willOpen = !item.classList.contains("is-open");
			item.classList.toggle("is-open", willOpen);
			button.setAttribute("aria-expanded", willOpen ? "true" : "false");
			button.setAttribute("aria-label", willOpen ? "Hide submenu" : "Show submenu");
		});
	});

	// Dropdown submenu positioning
	const dropdowns = document.querySelectorAll(".dropdown-hover");

	dropdowns.forEach((dropdown) => {
		dropdown.addEventListener("mouseenter", function () {
			const submenu = this.querySelector(":scope > .dropdown-menu");
			if (!submenu) return;

			// Reset any previous positioning
			submenu.classList.remove("dropdown-menu-start");

			// Check if submenu would overflow viewport
			const rect = submenu.getBoundingClientRect();
			const viewportWidth = window.innerWidth;

			if (rect.right > viewportWidth) {
				submenu.classList.add("dropdown-menu-start");
			}
		});
	});
});
